/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface StringAttributeDTO
 */
export interface StringAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof StringAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof StringAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof StringAttributeDTO
     */
    value: string;
}



/**
 * Check if a given object implements the StringAttributeDTO interface.
 */
export function instanceOfStringAttributeDTO(value: object): value is StringAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function StringAttributeDTOFromJSON(json: any): StringAttributeDTO {
    return StringAttributeDTOFromJSONTyped(json, false);
}

export function StringAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'value': json['value'],
    };
}

export function StringAttributeDTOToJSON(value?: StringAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'value': value['value'],
    };
}

